// JsFromRoutes CacheKey 7524766e0f2e92f8f9a7348c3bc96079
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  delivered: /* #__PURE__ */ definePathHelper('post', '/notifications/:id/delivered'),
}
